import { CommonModule } from "@angular/common";
import { inject, NgModule, provideAppInitializer } from "@angular/core";
import { AiEditorActionsService } from "@common/lib/chat-ai/ai-editor-actions.service";
import { AIFroalaAction } from "@common/lib/chat-ai/ai-froala-action";
import { AdaptCommonDialogModule } from "@common/ux/adapt-common-dialog/adapt-common-dialog.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptEditorViewModule } from "@common/ux/html-editor/editor-view.module";
import { AdaptHtmlEditorModule } from "@common/ux/html-editor/html-editor.module";
import { HtmlEditorService } from "@common/ux/html-editor/html-editor.service";
import { AdaptLoadingSpinnerModule } from "@common/ux/loading-spinner/loading-spinner.module";
import { AdaptMenuModule } from "@common/ux/menu/menu.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { DxButtonModule, DxChatModule, DxListModule, DxLoadIndicatorModule, DxLoadPanelModule, DxPopoverModule, DxScrollViewModule, DxSelectBoxModule, DxTabsModule, DxTextAreaComponent } from "devextreme-angular";
import { CollapseDirective } from "ngx-bootstrap/collapse";
import { AiActionDialogComponent } from "./ai-action-dialog/ai-action-dialog.component";
import { ChatAiComponent } from "./chat-ai/chat-ai.component";
import { ChatAiApplicationBarItemComponent } from "./chat-ai-application-bar-item/chat-ai-application-bar-item.component";
import { ChatAiSidebarContentComponent } from "./chat-ai-sidebar-content/chat-ai-sidebar-content.component";
import { ChatAiStickyDialogComponent } from "./chat-ai-sticky-dialog/chat-ai-sticky-dialog.component";
import { ConversationListComponent } from "./conversation-list/conversation-list.component";


@NgModule({
    declarations: [
        AiActionDialogComponent,
        ChatAiComponent,
        ChatAiApplicationBarItemComponent,
        ChatAiStickyDialogComponent,
        ChatAiSidebarContentComponent,
        ConversationListComponent,
    ],
    imports: [
        CommonModule,
        DxChatModule,
        DxButtonModule,
        DxTabsModule,
        DxLoadIndicatorModule,
        DxLoadPanelModule,
        DxPopoverModule,
        DxListModule,
        DxTextAreaComponent,
        DxSelectBoxModule,
        DxScrollViewModule,
        AdaptButtonModule,
        AdaptCommonDialogModule,
        AdaptTooltipModule,
        AdaptEditorViewModule,
        AdaptHtmlEditorModule,
        CollapseDirective,
        AdaptLoadingSpinnerModule,
        AdaptMenuModule,
    ],
    exports: [
        ChatAiComponent,
    ],
    providers: [
        // makes sure the AI froala action is registered
        provideAppInitializer(() => {
            const aiEditorActionsService = inject(AiEditorActionsService);
            const htmlEditorService = inject(HtmlEditorService);
            htmlEditorService.registerEditorActionCallback(() => AIFroalaAction.registerAction(aiEditorActionsService));
        }),
    ],
})
export class AdaptCommonChatAiModule { }
